// ABOUTME: Says so when a save is taking unusually long, instead of leaving a spinner that never stops.
// ABOUTME: Draws nothing of its own — it drives one sonner toast from the slow-save count.

import { useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"
import { toast } from "sonner"
import { useSlowMutationCount } from "@/graphql/client/slowMutation"

/** One id for every slow save: sonner updates the toast in place instead of stacking them. */
const NOTICE_ID = "slow-save"

/*
 * A write is never cut off — aborting one is not the same as failing it, because the server may have
 * applied it and the client cannot tell (see slowMutation.ts). So the request keeps running and this
 * only changes what the user is told: after the threshold, that it is still going and they need not
 * sit and wait. If the answer arrives the notice goes away and everything resolves as it always did.
 */
export const SlowSaveNotice = () => {
  const slowSaves = useSlowMutationCount()
  const { t } = useTranslation()
  // Without this the first render would dismiss a toast that was never shown.
  const isShown = useRef(false)

  useEffect(() => {
    if (slowSaves === 0) {
      if (!isShown.current) return
      isShown.current = false
      toast.dismiss(NOTICE_ID)
      return
    }

    isShown.current = true

    toast.loading(t("common.stillSaving", "Still saving — this is taking longer than usual"), {
      id: NOTICE_ID,
      description: t("common.stillSavingHint", "You can keep working"),
      // Dismissed by the count going back to zero, not by a clock: the save decides when it is over.
      duration: Infinity,
    })
  }, [slowSaves, t])

  return null
}
